import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import { ReactComponent as MarkerBlueIcon } from "../../img/icons/marker-blue.svg";
import { ReactComponent as MarkerOrangeIcon } from "../../img/icons/marker-orange.svg";
import { ReactComponent as MarkerGreyIcon } from "../../img/icons/marker-grey.svg";
import "./WelocateStatusFilter.css";

const STATUSES = [
  {
    value: "available",
    label: "Available",
    subtitle: "Open for viewings & bids",
    color: "#2F4B9B",
    Icon: MarkerBlueIcon,
  },
  {
    value: "sale_pending",
    label: "Under bid",
    subtitle: "Bid accepted, sale pending",
    color: "#E27C00",
    Icon: MarkerOrangeIcon,
  },
  {
    value: "sold",
    label: "Sold",
    subtitle: "Recently sold — reference",
    color: "#9CA3AF",
    Icon: MarkerGreyIcon,
  },
];

const WelocateStatusFilter = ({
  selected,
  onToggle,
  counts = {},
  totalCount = 0,
  onReset,
  onClose,
}) => (
  <div className="wl-status-filter">
    <div className="wl-status-filter__header">
      <h3 className="wl-status-filter__title">Listing status</h3>
      <button
        type="button"
        className="wl-status-filter__reset"
        onClick={onReset}
      >
        Reset
      </button>
    </div>
    <p className="wl-status-filter__lede">Show properties that are…</p>

    <div className="wl-status-filter__list">
      {STATUSES.map(({ value, label, subtitle, color, Icon }) => {
        const isSelected = selected.includes(value);
        const count = counts[value] ?? 0;
        return (
          <button
            key={value}
            type="button"
            className={`wl-status-filter__option${
              isSelected ? " wl-status-filter__option--selected" : ""
            }`}
            style={{ "--wl-status-color": color }}
            onClick={() => onToggle(value)}
          >
            <Icon className="wl-status-filter__pin" />
            <span className="wl-status-filter__dot" />
            <span className="wl-status-filter__text">
              <span className="wl-status-filter__label">{label}</span>
              <span className="wl-status-filter__subtitle">{subtitle}</span>
            </span>
            <span className="wl-status-filter__count">{count}</span>
            <span className="wl-status-filter__checkbox">
              {isSelected && <CheckIcon className="wl-status-filter__check" />}
            </span>
          </button>
        );
      })}
    </div>

    <button
      type="button"
      className="wl-status-filter__apply"
      onClick={onClose}
    >
      Show {totalCount} properties
    </button>
  </div>
);

export default WelocateStatusFilter;
